export const VERIFY_MAIL = "verify_mail"
export const VERIFY_MAIL_SUCCESSFUL = "verify_mail_successfull"
export const VERIFY_MAIL_FAILED = "verify_mail_failed"

//verify accesstoken
export const VERIFY_ACCESS_TOKEN = "VERIFY_ACCESS_TOKEN"
export const VERIFY_ACCESS_TOKEN_SUCCESS = "VERIFY_ACCESS_TOKEN_SUCCESS"
export const VERIFY_ACCESS_TOKEN_FAILED = "VERIFY_ACCESS_TOKEN_FAILED"
